import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { AppConstants } from "../../constants/app-constants";
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Page } from "../utils/requisition/pages";


@Injectable({
  providedIn: 'root'
})
export class RequirementService {

  constructor(private http: HttpClient) { }



  // gets the custome filters for all the fileds in search
  getCustomFilter(module, orgid, filterParam, searchParam, rangeParam) {
    const url = environment.SERVER_URL + AppConstants.CUSTOM_FILTER;
    let str = '';
    if (filterParam != null) {
      const keys = Object.keys(filterParam);
      for (const key of keys) {
        if (filterParam[key] !== '') {
          if (str !== '') {
            str = str + '&';
          }
          str = str + 'filter' + key + '=' + encodeURIComponent(filterParam[key]);
        }
      }
    }
    if (searchParam != null) {
      const skeys = Object.keys(searchParam);
      for (const key of skeys) {
        if (searchParam[key] !== '') {
          if (str !== '') {
            str = str + '&';
          }
          str = str + 'search' + key + '=' + searchParam[key];
        }
      }
    }
    return this.http.get(url + '?' + str, {
      params: {
        module: module,
        orgid: orgid
      }
    });
  }


  // gets the listview by taking in the filters and page to be fetched
  searchAndFilterData(
    orgid: number,
    page: Page,
    sortColumn?: string,
    sortOrder?: string,
    filterParam?,
    searchParam?,
    expFilterParam?) {
    const url = environment.SERVER_URL + AppConstants.REQSEARCHFILTER;

    let str = '';
    if (filterParam != null) {
      const keys = Object.keys(filterParam);
      for (const key of keys) {

        if (filterParam[key] !== '') {
          if (str !== '') {
            str = str + '&';
          }
          str = str + 'filter' + key + '=' + encodeURIComponent(filterParam[key]);
        }
      }
    }
    if (searchParam != null) {
      const skeys = Object.keys(searchParam);
      for (const key of skeys) {
        if (searchParam[key] !== '') {
          if (str !== '') {
            str = str + '&';
          }
          str = str + 'search' + key + '=' + encodeURIComponent(searchParam[key]);
        }
      }
    }

    let params = new HttpParams();
    params = params.append('page', page.pageNumber.toString());
    params = params.append('size', page.size.toString());
    params = params.append('sort', [sortColumn, sortOrder].toString());
    if (expFilterParam && expFilterParam != null && expFilterParam >= 0) {
      params = params.append('exprangefilter', expFilterParam.toString());
    }
    params = params.append('orgid', orgid.toString());
    const options = {
      params: params
    };
    return this.http.get(url + '?' + (str),
      options
    );
  }

  // Observable string sources
  private requisitionDataSource = new BehaviorSubject<any>('');
  // Observable string streams
  requisitionData$ = this.requisitionDataSource.asObservable();
  // Service message commands
  shareRequistionDataSource(data: any) {
    this.requisitionDataSource.next(data);
  }

  getRequisitionDataSource(): Observable<any> {
    return this.requisitionDataSource.asObservable();
  }

  // // Observable string sources
  // private isApplicationTab = new BehaviorSubject<any>('');
  // // Observable string streams
  // applicationTab$ = this.requisitionDataSource.asObservable();
  // // Service message commands
  // setApplicationTabVisibility(data: any) {
  //   this.isApplicationTab = data;
  // }

  // getApplicationTabVisibility(): Observable<any> {
  //   return this.isApplicationTab;
  // }

  // gets the requirement by its id and orgid
  getRequirementById(reqid, orgid) {
    const url = environment.SERVER_URL + AppConstants.GET_REQUIREMENT_BY_ID;
    return this.http.get(url + '?', {
      params: {
        reqid: reqid.toString(),
        orgid: orgid.toString(),
      }
    });
  }

  // gets all the options for designation field
  getDesignationSuggestion(input) {
    const url = environment.SERVER_URL + AppConstants.REQUIREMENT_DESIGNATION_SUGGESTION;
    return this.http.get(url + '?', {
      params: {
        inputstring: input,
        orgid: "1"
      }
    });
  }

  // gets all the options for reqcode field
  getReqcodeSuggestion(input) {
    const url = environment.SERVER_URL + AppConstants.REQUIREMENT_REQCODE_SUGGESTION;
    return this.http.get(url + '?', {
      params: {
        inputstring: input,
        orgid: "1"
      }
    });
  }

  // gets the count of all the available jobs
  getAllJobsCount(orgId) {
    const url = environment.SERVER_URL + AppConstants.GET_ALL_JOBS_COUNT;
    return this.http.get(url, {
      params: {
        orgid: orgId
      }
    });
  }


}

